import React, { useContext, useState } from 'react';

import { createAnexoDemanda } from '@app/api/demanda';
import {
  Button,
  CrudContext,
  FormatText,
  FormInput,
  FormSubmitButton,
  MasterDetailForm,
  Row,
  Widget,
} from '@digital/ui';
import { Modal } from 'antd';

import { UploadFile } from '@app/components';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';

interface Props {
  getTemplates: (id: string) => Promise<void>;
}

function ModalCreateDocumento(props: Props) {
  const { getTemplates } = props;
  const { demandaData } = useContext(QuestionarioContextProvider);
  const [exibirModal, setExibirModal] = useState(false);
  const [arquivo, setArquivo] = useState<boolean>(true);

  const handleSubmit = (values: any) => {
    if (demandaData) {
      values.demandaId = demandaData.id;
      createAnexoDemanda(values).then(data => {
        if (data.valid) {
          getTemplates(demandaData.id);
          setExibirModal(false);
        }
      });
    }
  };

  return (
    <>
      <>
        <Button
          id='mrn-button-modal-ModalCreateDocumento-incluir'
          style={{ borderRadius: '3px', marginBottom: '10px' }}
          type="primary"
          onClick={() => {
            setExibirModal(true);
          }}>
          INCLUIR OUTRO ARQUIVO
        </Button>
      </>
      <Modal
        title="INCLUIR ANEXO"
        width="680px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        {exibirModal &&
          <MasterDetailForm
            key="formAnexo"
            onSubmit={handleSubmit}
            actions={[
              <Button
                id='mrn-button-modal-ModalCreateDocumento-fechar'
                type="link"
                onClick={() => {
                  setExibirModal(false);
                }}
                key="close">
                Fechar
              </Button>,
              <FormSubmitButton
                id='mrn-button-modal-ModalCreateDocumento-salvar'
                noIcon type="primary" key="save">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row>
                <FormInput
                  label="Descrição do Documento"
                  name="descricaoDocumento"
                  id='mrn-input-modal-ModalCreateDocumento-descricaoDocumento'
                  span={12} required />
                <UploadFile
                  idDoComponente='mrn-input-upload-modal-ModalCreateDocumento-arquivo'
                  nameFormData={'arquivo'}
                  label={'INSERIR ANEXO'}
                  hasFile={arquivo} type="primary" />
              </Row>
            </Widget>
          </MasterDetailForm>
        }
      </Modal>
    </>
  );
}

export default ModalCreateDocumento;
